const PermissionPage = () => {
    return <div className='p-3'>
        <h2 className='text-secondary'>You don't have permission to access this page.</h2>
    </div>;
};

export default PermissionPage;
